import { ArrowLeft, Pencil } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { TemplateFormDialog } from "@/features/stage-templates/components/template-form-dialog";
import {
	TemplateItemsTable,
	TemplateItemsTableSkeleton,
} from "@/features/stage-templates/components/template-items-table";
import { useStageTemplate } from "@/features/stage-templates/hooks/use-stage-template.ts";
import { usePermissions } from "@/hooks/use-permissions.ts";

export function StageTemplateDetailPage() {
	const { obra, templateId } = useParams();
	const { has } = usePermissions();
	const canUpdate = has("stage_templates:update");
	const query = useStageTemplate(templateId);
	const [editOpen, setEditOpen] = useState(false);

	const listPath = `/${obra}/configuracoes/templates-de-etapas`;

	if (query.isPending) {
		return (
			<div className="template-detail-page">
				<div className="template-detail-page__topbar">
					<Skeleton className="template-detail-page__skeleton-back" />
					<div className="template-detail-page__header">
						<div className="template-detail-page__skeleton-heading">
							<Skeleton className="template-detail-page__skeleton-title" />
							<Skeleton className="template-detail-page__skeleton-subtitle" />
						</div>
					</div>
				</div>
				<TemplateItemsTableSkeleton />
			</div>
		);
	}

	if (query.isError || !query.data) {
		return (
			<Card className="card-narrow">
				<CardContent className="card-state">
					<p>Template não encontrado.</p>
					<Button asChild variant="outline">
						<Link to={listPath}>
							<ArrowLeft />
							Voltar para templates
						</Link>
					</Button>
				</CardContent>
			</Card>
		);
	}

	const { template, items } = query.data;

	return (
		<div className="template-detail-page">
			<div className="template-detail-page__topbar">
				<Button
					asChild
					variant="ghost"
					size="sm"
					className="template-detail-page__back"
				>
					<Link to={listPath}>
						<ArrowLeft />
						Templates
					</Link>
				</Button>
				<div className="template-detail-page__header">
					<div>
						<h1 className="page-title">{template.name}</h1>
						{template.description && (
							<p className="page-subtitle">{template.description}</p>
						)}
					</div>
					{canUpdate && (
						<Button variant="outline" onClick={() => setEditOpen(true)}>
							<Pencil />
							Editar template
						</Button>
					)}
				</div>
			</div>

			{/* biome-ignore lint/style/noNonNullAssertion: detail loaded means templateId is set */}
			<TemplateItemsTable templateId={templateId!} items={items} />

			<TemplateFormDialog
				open={editOpen}
				onOpenChange={setEditOpen}
				mode="edit"
				template={template}
			/>
		</div>
	);
}
